/**
 * File: singleActivityReport.js
 * Project: educore
 * Created Date: 2019-01-29
 * Author: Raziya S
 * Copyright (c) 2018 Cordova Cloud Solutions Pvt Ltd
 * ------------------------------------
 */
class ActivityReportsController {
    // @ngInject
    constructor($scope, $state, $rootScope, authService, localStorageService, UserPrivilages, TPWIZARDCONSTANT, $stateParams, activityCons, SchoolLogo, CONSTANTS) {
        //On init function
        this.$onInit = () => {
            $rootScope.isLoggedIn = localStorageService.get("is_login") ? localStorageService.get("is_login") : false
            if (!$rootScope.isLoggedIn) {
                $state.go("login", {}, {
                    reload: true
                })
            }
        }

        //On destroy function
        this.$onDestroy = () => {}
        //String - Question paper id
        let qpId = $state.params.qpId;
        var authoring = localStorageService.get('authoringData')
        var schoolId = authoring.school_id
        var academicYear = authoring.academic_year
        $scope.isLoading = true

        //[Object] - Contains chart data
        $scope.chartArray = []

       //Number - To set width of chart
        $scope.chartWidth = 525;

        //Number - To set height of chart
        $scope.chartHeight = 350;

        //[Object] - Holds list of chart details
        $scope.chartImgData = []

        $scope.colorArray = ['#3366cc', '#f59f00', '#109618']

        //[Object] - Holds list of chart details
        $scope.chartImgData = []

        //[Object] - chart availability
        $scope.chartAvailability = {
            isQuesVsStudent: false
        }
        $scope.quesCount = 0
        $scope.studCount = 0
        $scope.studAttendCount = 0
        $scope.absentees = 0
        $scope.imgurl1 = undefined
        authService.callAPI(activityCons.API_GET_SCHOOL_DETAILS + schoolId, "POST", {
            file_server : CONSTANTS.FILE_UPLOAD_URL
        }, (response) => {
            if (response.result && response.result.status && response.result.data.details) {
                let result = response.result.data.details
                $scope.schoolHeader = {
                    'schoolName': result.school_name,
                    'schoolLogo': result.logo,
                    'academicYear': academicYear
                }
                convertFileToDataURLviaFileReader($scope.schoolHeader.schoolLogo, function(base64Image) {
                    $scope.imgurl1 = base64Image;
                })
            }
        })
        authService.callAPI(TPWIZARDCONSTANT.API_GET_ACTIVITY_REPORT + qpId, "GET", {}, function(response) {
            if (response.result && response.result.data) {
                let resultData = response.result.data
                console.log(resultData)
                if(resultData && resultData.basicDetails && resultData.basicDetails.length>0)
                {
                    if(resultData.basicDetails[0].total_questions)
                       $scope.quesCount = resultData.basicDetails[0].total_questions
                    if(resultData.basicDetails[0].total_students)
                       $scope.studCount = resultData.basicDetails[0].total_students
                    if(resultData.basicDetails[0].attendend_students)
                       $scope.studAttendCount = resultData.basicDetails[0].attendend_students
                    if(resultData.basicDetails[0].absentees_students)
                       $scope.absentees = resultData.basicDetails[0].absentees_students
                }
              if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                    if (resultData.graphDetails && resultData.graphDetails.length > 0) {
                        if (resultData.graphDetails[0].questionDetail ) {
                            if (resultData.graphDetails[0].questionDetail.length > 0) {
                                let questionDetail = resultData.graphDetails[0].questionDetail
                                let values = []
                                let header = []
                                header.push("Question")
                                header.push("No. of students Attended")
                                header.push("No. of Correct Answers")
                                values.push(header)
                                _.each(questionDetail, function(data, index) {
                                    let arr = []
                                    let question = "Q" + (index +1)
                                    arr.push(question)
                                    arr.push(data.attended_count)
                                    arr.push(data.crct_answer_count)
                                    values.push(arr)
                                })
                                $scope.quesObj = {
                                    'key': "Question",
                                    'graph': "Bar",
                                    'title': "Question" + '  vs  ' + "Count",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.quesObj)
                                $scope.isLoading = false
                                $scope.isChartAvailable = true
                            }
                        }
                        if (resultData.graphDetails[0].waveDetails) {
                            if (resultData.graphDetails[0].waveDetails.length > 0) {
                                let waveDetails = resultData.graphDetails[0].waveDetails
                                let values = []
                                let header = []
                                header.push("Wave")
                                header.push("Total Questions")
                                header.push("No. of students Attended")
                                header.push("No. of Correct Answers")
                                values.push(header)
                                _.each(waveDetails, function(data) {
                                    let arr = []
                                    arr.push(data.wave[0].wave)
                                    arr.push(data.question_count)
                                    arr.push(data.attended_count)
                                    arr.push(data.crct_answer_count)
                                    values.push(arr)
                                })
                                $scope.waveObj = {
                                    'key': "wave",
                                    'graph': "Bar",
                                    'title': "Wave" + '  vs  ' + "Count",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.waveObj)
                                $scope.isLoading = false
                            }
                        }
                        if (resultData.graphDetails[0].tagDetails) {
                            if (resultData.graphDetails[0].tagDetails.length > 0) {
                                let tagDetails = resultData.graphDetails[0].tagDetails
                                let values = []
                                let header = []
                                header.push("Tag")
                                header.push("Total Questions")
                                header.push("No. of students Attended")
                                header.push("No. of Correct Answers")
                                values.push(header)
                                _.each(tagDetails, function(data) {
                                    let arr = []
                                    arr.push(data._id)
                                    arr.push(data.question_count)
                                    arr.push(data.attended_count)
                                    arr.push(data.crct_answer_count)
                                    values.push(arr)
                                })
                                $scope.tagObj = {
                                    'key': "wave",
                                    'graph': "Bar",
                                    'title': "Tag" + '  vs  ' + "Count",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.tagObj)
                                $scope.isLoading = false
                            }
                        }
                        if (resultData.graphDetails[0].levelDetails) {
                            if (resultData.graphDetails[0].levelDetails.length > 0) {
                                let levelDetails = resultData.graphDetails[0].levelDetails
                                let values = []
                                let header = []
                                header.push("Level")
                                header.push("Total Questions")
                                header.push("No. of students Attended")
                                header.push("No. of Correct Answers")
                                values.push(header)
                                _.each(levelDetails, function(data) {
                                    let arr = []
                                    arr.push(data.level[0].level)
                                    arr.push(data.question_count)
                                    arr.push(data.attended_count)
                                    arr.push(data.crct_answer_count)
                                    values.push(arr)
                                })
                                $scope.levelObj = {
                                    'key': "level",
                                    'graph': "Bar",
                                    'title': "Level" + '  vs  ' + "Count",
                                    'value': values
                                }
                                $scope.chartArray.push($scope.levelObj)
                                $scope.isLoading = false
                            }
                        }
                    }
                }
                if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                    let rankDetails = resultData.rankDetails
                    let isPresent = 0
                    let values = []
                    let header = []
                    header.push("Student")
                    header.push("Marks Scored")
                    values.push(header)
                    _.each(rankDetails, function(data) {
                        let arr = []
                        arr.push(data.student_name)
                        arr.push(data.score)
                        values.push(arr)
                        if (data.score)
                            isPresent++
                    })
                    $scope.levelObj = {
                        'key': "level",
                        'graph': "Bar",
                        'title': "Student" + '  vs  ' + "Mark",
                        'value': values
                    }
                    if (isPresent > 0)
                        $scope.chartArray.push($scope.levelObj)
                }
                if (resultData.rankDetails && resultData.rankDetails.length > 0) {
                    let rankDetails = resultData.rankDetails
                    let isPresent = 0
                    let values = []
                    let header = []
                    header.push("Student")
                    header.push("Rank")
                    values.push(header)
                    _.each(rankDetails, function(data) {
                        let arr = []
                        arr.push(data.student_name)
                        arr.push(data.rank)
                        values.push(arr)
                        if (data.rank)
                            isPresent++
                    })
                    $scope.levelObj = {
                        'key': "level",
                        'graph': "Bar",
                        'title': "Student" + '  vs  ' + "Rank",
                        'value': values
                    }
                    if (isPresent > 0)
                        $scope.chartArray.push($scope.levelObj)
                }

                _.defer(function() {
                    $scope.$apply();
                });
            }
        });
        
        

        

        $scope.barOptions = {
            responsive: true,
            scaleBeginAtZero: true,
            scaleShowGridLines: false,
            barValueSpacing: 1,
            barDatasetSpacing: 1,
            tooltipEvents: ["mousemove", "mouseout", "click", "touchstart", "touchmove", "touchend"],
            legend: {
                display: false,
            },
            scales: {
                xAxes: [{
                    barPercentage: 0.9,
                    categoryPercentage: 0.5
                }],
                yAxes: [{
                    ticks: {
                        stepSize: 1,
                        beginAtZero: true // minimum value will be 0.
                    }
                }]
            },
        }

        /*
         * Function to go back to activity page
         *
         * @return - null
         *
         */
        $scope.goBack = () => {
            $state.go("activityReports")
        }

        function convertFileToDataURLviaFileReader(url, callback) {
            var xhr = new XMLHttpRequest();
            xhr.onload = function() {
                var reader = new FileReader();
                reader.onloadend = function() {
                    callback(reader.result);
                }
                reader.readAsDataURL(xhr.response);
            };
            xhr.open('GET', url);
            xhr.responseType = 'blob';
            xhr.send();
        };

        /*
         * To get chart details from Child chart component
         * 
         * @data : Object - Chart details
         * 
         * @return : null
         */
        $scope.getChartData = function(data) {
            if (data != undefined && data[0] != undefined) {
                $scope.chartImgData.push(data[0])
            }
        }

        /*
         * To export chart as PDF file
         * 
         * @return : null
         */
        $scope.exportAsPDF = function() {
            var doc = new jsPDF('p', 'pt', 'a4', false) /* Creates a new Document*/
            if($scope.imgurl1){
                doc.addImage($scope.imgurl1, 'png', 50, 30, 70, 70, undefined, 'none');
            }
            
            doc.setFontSize(18);
            doc.setFontType('bold');
            var xOffset = (doc.internal.pageSize.width / 2) - (doc.getStringUnitWidth($scope.schoolHeader.schoolName) * doc.internal.getFontSize() / 2);
            doc.text(xOffset, 50, $scope.schoolHeader.schoolName);
            doc.setFontSize(12);
            doc.setFontType('normal');
            doc.text(230, 70, 'Academic Year : ' + $scope.schoolHeader.academicYear);
            doc.setFontSize(16);
            doc.text(220, 90, 'Activity Based Report');
            doc.setFontSize(15); /* Define font size for the document */
            var yAxis = 150;

            for (var i = 0; i < $scope.chartImgData.length; i++) {
                if (i % 2 == 0 && i != 0) { /* I want only two images in a page */
                    doc.addPage(); /* Adds a new page*/
                    yAxis = 30; /* Re-initializes the value of yAxis for newly added page*/
                }

                var width = doc.internal.pageSize.width; //$scope.imageTags[i].width;
                var height = $scope.chartImgData[i].height - 100; //doc.internal.pageSize.height;

                if (doc.internal.pageSize.width <= $scope.chartImgData[i].width) {
                    width = doc.internal.pageSize.width;
                } else {
                    width = $scope.chartImgData[i].width;
                }

                height = $scope.chartImgData[i].height * width / doc.internal.pageSize.width;
                height = width * (3 / 4) - 100

                var someText = (i + 1) + ".) " + $scope.chartImgData[i].title;
                doc.text(60, yAxis, someText); /* Add some text in the PDF */
                yAxis = yAxis + 20; /* Update yAxis */
                //doc.addImage($scope.imageTags[i].image, 'png', 40, yAxis, 530, 350, undefined, 'none');
                doc.addImage($scope.chartImgData[i].image, 'png', 0, yAxis, width, height, undefined, 'none');
                yAxis = yAxis + 360; /* Update yAxis */
            }
            window.open(doc.output('bloburl'))
                // doc.save('Activity_Based_Report.pdf')
        }
       
    };
}

export default ActivityReportsController;


// WEBPACK FOOTER //
// ./src/app/authoring-tool/wizard/controllers/reports/singleActivityReport.js